<rt-box variant="vertical">
  @if (question().aggregate; as aggregate) {
    @switch (aggregate.type) {
      @case (AggregateType.Responses) {
        <rt-candidate-offer-evaluation-question-responses
          [questionTitle]="question().questionTitle"
          [answersCount]="question().answersCount"
          [commentsCount]="question().notes.length"
          [responses]="aggregate.responses"
          [questionKind]="question().questionKind"
        />
      }
      @case (AggregateType.OptionsDistribution) {
        @if (theme(); as theme) {
          <rt-candidate-offer-evaluation-question-options-distribution
            [questionTitle]="question().questionTitle"
            [answersCount]="question().answersCount"
            [commentsCount]="question().notes.length"
            [options]="aggregate.options"
            [theme]="theme"
          />
        }
      }
      @case (AggregateType.BooleanDistribution) {
        @if (theme(); as theme) {
          <rt-candidate-offer-evaluation-question-boolean-distribution
            [questionTitle]="question().questionTitle"
            [answersCount]="question().answersCount"
            [commentsCount]="question().notes.length"
            [yes]="aggregate.yes"
            [no]="aggregate.no"
            [theme]="theme"
          />
        }
      }
      @case (AggregateType.Attachments) {
        <rt-candidate-offer-evaluation-question-attachments
          [questionTitle]="question().questionTitle"
          [answersCount]="question().answersCount"
          [commentsCount]="question().notes.length"
          [attachments]="aggregate.attachments"
        />
      }
      @case (AggregateType.Skills) {
        <rt-candidate-offer-evaluation-question-skills
          [questionTitle]="question().questionTitle"
          [answersCount]="question().answersCount"
          [commentsCount]="question().notes.length"
          [skills]="aggregate.skills"
          [theme]="theme()"
          [showPositionButton]="showPositionButton()"
          (viewPosition)="viewPosition.emit()"
        />
      }
    }
  }

  @if (question().notes.length) {
    <rt-candidate-offer-evaluation-question-comments
      [notes]="question().notes"
      [useProsemirror]="useProsemirror()"
    />
  }
</rt-box>
